<template>
    <tr :class="trClass">
        <td class="v-align-middle"
            @click="onClick">
            <i v-if="isVip"
               class="fa fa-star"></i>
        </td>
        <td @click="onClick"
            class="society-group">
            <ul class="society">
                <li>
                    <i v-if="showVigilance"
                       class="circle"
                       :class="[vigilanceStatusClass]"></i>
                    {{customer.name}} {{initials}}
                </li>
                <li v-if="customer.erp_id">
                  #SAP {{customer.erp_id}}    
                </li>
                <li>{{customer.trade_name}}</li>
                <li>
                    <span class="badge">{{customer.decoded_status}}</span>
                </li>
            </ul>
        </td>
        <td class="v-align-middle"
            @click="onClick">
            <ul class="name"
                v-if="mainRepresentative">
                <li>{{mainRepresentative.title}}</li>
                <li>{{mainRepresentative.quality}}</li>
            </ul>
        </td>
        <td class="v-align-middle"
            @click="onClick">
            <template v-for="contract in filteredContracts">
                <ul class="contract"
                    :key="'customer-item-contract'+contract.id"
                    v-if="!contract.order.cancelled">
                    <li>
                        <span class="micrologo"
                            :class="contractClass(contract)"></span>
                        {{normalizedContractType(contract)}}    
                    </li>
                    <template v-if="isDomiciliation(contract)">
                        <li>{{normalizedContractState(contract)}}</li>
                        <li v-if="hasHotline(contract)"
                            v-html="normalizedHotlineState(contract)"></li>
                    </template>
                    <li v-else-if="hasOfficeNumber(contract)"
                        v-html="normalizedOfficeState(contract)"></li>
                    <li v-else>Aucun bureau</li>
                    <li v-if="contract.order && contract.order.sap_promo_code">
                        <span class="label">Code promo : {{ contract.order.sap_promo_code }}</span>
                    </li>
                </ul>
            </template>
        </td>
        <td class="v-align-middle"
            @click="onClick">
            <template v-for="contract in filteredContracts">
                <ul class="options"
                    :key="'customer-item-contract-proxies'+contract.id"
                    v-if="!contract.order.cancelled">
                    <li>
                        <i class="fa"
                        :class="handleContractFlag(contract, 'package_reception')"></i>Colis</li>
                    <li>
                        <i class="fa"
                        :class="handleContractFlag(contract, 'postal')"></i>Procuration</li>
                    <li>
                        <i class="fa"
                        :class="handleContractFlag(contract, 'registered_letter_calls')"></i>Notif. si LR</li>
                    <li>
                        <i class="fa"
                        :class="handleContractFlag(contract, 'mail_blocked')"></i>Courrier bloqué</li>
                </ul>
            </template>
        </td>
        <td class="v-align-middle">
            <router-link :to="{ name: 'customer', params: { id: customer.id } }">
                <button class="btn btn-default btn-sm m-t-10">Détails</button>
            </router-link>
        </td>
    </tr>
</template>

<script type="text/babel">
    import contractsMixin from 'mixins/contracts'
    import customerMixin from 'mixins/customer'

    export default {

        mixins: [contractsMixin, customerMixin],

        props: ['customer', 'showDetails', 'hasDetails'],

        computed: {
            trClass () {
                return { shown: this.showDetails, 'has-details': this.hasDetails }
            },

            initials () {
                const initials = this.customer.initials
                return initials ? `(${initials})` : ""
            },

            isVip () {
                return this.customer.type === "cadre"
            },

            mainRepresentative () {
                const rep = this.customer.hasOwnProperty('main_representative') ?
                    this.customer.main_representative : false

                return rep && {
                    title: `${rep.decoded_civility ? rep.decoded_civility : ""} ${rep.first_name ? rep.first_name : ""} ${rep.last_name}`,
                    quality: rep.decoded_representative_quality
                }
            },

            filteredContracts() {
                return this.getFilteredContractsList(this.customer.contracts)
            }
        },

        methods: {

            handleCustomerFlag (flag) {
                return (flag) ? "fa-check" : "fa-close"
            },

            handleContractFlag (contract, name) {
                return this.contractWithInstruction(contract, name) ? "fa-check" : "fa-close"
            },

            normalizedContractType (contract) {
                return (this.isDomiciliation(contract)) ?
                    contract.decoded_domiciliation_type : "Location longue-durée"
            },

            contractClass (contract) {
                return [contract.organization_name]
            },

            onClick ($event) {
                if (this.hasDetails)
                    this.$emit('click', $event)
            },

        }
    }
</script>

<style lang="scss" scoped>
    @import '~pages_sass/_var.scss';

    .consignes {
        vertical-align: baseline !important;
    }

    .fa-star {
        position: absolute;
        left: -25px;
    }

    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    .society-group {
        .society {
            li {
                &:first-child {
                    text-transform: uppercase;
                }
            }
        }
    }

    .society,
    .name {
        li {
            &:last-child {
                font-size: 0.7rem;
            }
        }
    }

    .contract {
        font-size: 0.7rem;
        position: relative;
        overflow: visible;
        &:not(:only-child) {
            margin-top: 5px;
            min-height: 90px;
        }
        &:not(:first-child) {
            margin-top: 30px;
        }
        .sofradom {
            background: url('#{$base-img-url}/brand-logos/logo-sofradom.png') no-repeat 50% / contain;
        }
        .sdm {
            background: url('#{$base-img-url}/brand-logos/logo-sdm.png') no-repeat 50% / contain;
        }
        .abc_plus {
            background: url('#{$base-img-url}/brand-logos/logo-abc.png') no-repeat 50% / contain;
        }
        .micrologo {
            position: absolute;
            font-size: 1rem;
            left: -30px;
            top: 2px;
            width: 25px;
            height: 20px;
        }
    }

    .options {
        &:not(:only-child) {
            margin-top: 5px;
            min-height: 90px;
        }
        &:not(:first-child) {
            margin-top: 30px;
            padding-top: 10px;
        }


        li {
            font-size: 0.6rem;
            line-height: 1rem;
            i {
                &.fa-close {
                    font-size: 0.7rem;
                    color: #BBB;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// client/components/CustomersList/Item.vue